









import { Vue, Component, Prop } from "vue-property-decorator";

/**
 * This component can be used to display some text in read-only format.
 * It has special styles and differs from a input field with readonly attribute.
 */
@Component({})
export default class AnxReadonly extends Vue {
  /** If this attribute is set, the text will be selected and copied when a user clicks on it */
  @Prop({ default: null }) copyOnClick!: boolean | null;

  /** Display the text in bold */
  @Prop({ default: null }) bold!: boolean | null;

  /** Handle a click on the readonly */
  private click() {
    if (this.copyOnClick !== null) {
      this.copy(this.$el.childNodes[0] as HTMLElement);
    }
  }

  /** Select and copy the text of the area */
  public copy(elem: HTMLElement | null = null) {
    if (!elem) {
      elem = this.$el.childNodes[0] as HTMLElement;
    }

    try {
      // Select the text
      const range = document.createRange();
      range.selectNode(elem);

      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }

      // Try to copy the selected text
      document.execCommand("copy");
    } catch (e) {
      // Browser is unable to execute copy command
      return false;
    }

    /**
     * This event will be emitted after the content has successfully been copied to the clipboard
     *
     * @event copied
     */
    this.$emit("copied");

    return true;
  }
}
